import {
  AutomationType,
  TriggerType,
  UpdateRecordList,
  JobAutomationUpdateRecordFirstColumn,
  PlacementAutomationUpdateRecordFirstColumn,
  AutomationUpdateRecordFirstColumn,
  AutomationClientUpdateRecordFirstColumn,
  JobAutomationClientUpdateRecordFirstColumn,
  PlacementAutomationClientUpdateRecordFirstColumn,
} from "helpers/enum";

// The "Choose field" option list for an Update record step, before provider labels are resolved.
export const getUpdateRecordOptions = (triggerType, automationType) => {
  const isCandidate = automationType === AutomationType.Candidate;
  if (triggerType === TriggerType.JobBased) {
    return isCandidate ? JobAutomationUpdateRecordFirstColumn : JobAutomationClientUpdateRecordFirstColumn;
  }
  if (triggerType === TriggerType.PlacementBased) {
    return isCandidate ? PlacementAutomationUpdateRecordFirstColumn : PlacementAutomationClientUpdateRecordFirstColumn;
  }
  return isCandidate ? AutomationUpdateRecordFirstColumn : AutomationClientUpdateRecordFirstColumn;
};

// Placement/Job/Application custom fields are a single shared dataset per entity (not split by automationType);
// pick the set that matches the automation's triggerType (and, for Job-based / Placement-based candidate
// automations, which top-level section the user picked — Job vs Application, or Placement vs Candidate —
// since those are separate picker sections). Each field is tagged with the entity-specific recordField
// value backend expects on save (falls back to the generic CustomFields value for candidate/contact
// fields, which aren't split by entity).
export const getCustomFieldsForTriggerType = ({ triggerType, automationType, recordField, lookups }) => {
  const { candidateCustomFields, clientCustomFields, placementCustomFields, jobCustomFields, applicationCustomFields } = lookups;
  const tag = (fields, updateRecordType) => (fields || []).map(field => ({ ...field, updateRecordType }));

  if (triggerType === TriggerType.PlacementBased) {
    if (automationType !== AutomationType.Candidate) {
      // Contact and Placement Custom Fields are separate picker sections; contact fields save as CustomFields.
      return recordField === UpdateRecordList.CustomFields
        ? tag(clientCustomFields, UpdateRecordList.CustomFields)
        : tag(placementCustomFields, UpdateRecordList.PlacementCustomFields);
    }
    // Candidate, Placement, and Job Custom Fields are separate top-level picker sections (candidate-only);
    // which one is offered here depends on which section the user picked.
    if (recordField === UpdateRecordList.CustomFields) {
      return tag(candidateCustomFields, UpdateRecordList.CustomFields);
    }
    if (recordField === UpdateRecordList.JobCustomFields) {
      return tag(jobCustomFields, UpdateRecordList.JobCustomFields);
    }
    return tag(placementCustomFields, UpdateRecordList.PlacementCustomFields);
  }
  if (triggerType === TriggerType.JobBased) {
    if (automationType !== AutomationType.Candidate) {
      // Contact and Job Custom Fields are separate picker sections; contact fields save as CustomFields.
      return recordField === UpdateRecordList.CustomFields
        ? tag(clientCustomFields, UpdateRecordList.CustomFields)
        : tag(jobCustomFields, UpdateRecordList.JobCustomFields);
    }
    // Candidate, Job, and Application Custom Fields are separate top-level picker sections (candidate-only);
    // which one is offered here depends on which section the user picked.
    if (recordField === UpdateRecordList.CustomFields) {
      return tag(candidateCustomFields, UpdateRecordList.CustomFields);
    }
    if (recordField === UpdateRecordList.ApplicationCustomFields) {
      return tag(applicationCustomFields, UpdateRecordList.ApplicationCustomFields);
    }
    return tag(jobCustomFields, UpdateRecordList.JobCustomFields);
  }
  return tag(
    automationType === AutomationType.Candidate ? candidateCustomFields : clientCustomFields,
    UpdateRecordList.CustomFields
  );
};
